import { Product, ProductType } from '../context/CartContext';
import { snapCharmsProducts } from './products/snapCharmsProducts';
import { sportsProducts } from './products/sportsProducts';
import { localsProducts } from './products/localsProducts';
import { storeFrontProducts } from './products/storeFrontProducts';
import { calculateProductPrice } from '../utils/pricing';

export const arkansasTrademarkedSportNames = [
  "RAZORBACKS",
  "ARKANSAS RAZORBACKS",
  "HOGS",
  "HOG",
  "RAZORBACK",
  "WOOO PIG SOOIE",
  "Calling the Hogs",
  "Red Wolves",
  "Arkansas Travelers",
  "Travelers",
  "Traveler",
  "Red Wolves",
  "RedWolves"
];

// Combine all products from category files
const baseProducts: Product[] = [
  ...snapCharmsProducts,
  ...sportsProducts,
  ...localsProducts,
  ...storeFrontProducts
];

const products: Product[] = baseProducts.map(product => ({
  ...product,
  price: calculateProductPrice(product),
}));

// Product Service Functions
export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsByType = (productType: ProductType): Product[] => {
  return products.filter(product => product.product_type === productType);
};

export const getAllProducts = (): Product[] => {
  return [...products]; // Return a copy to prevent mutations
};

export const getProductsByCategory = (category: string): Product[] => {
  return products.filter(product => product.category === category);
};

export const getProductsBySubCategory = (subCategory: string): Product[] => {
  return products.filter(product => product.sub_category === subCategory);
};

export const searchProducts = (searchTerm: string): Product[] => {
  const term = searchTerm.toLowerCase();
  return products.filter(product => 
    product.name.toLowerCase().includes(term) ||
    product.description?.toLowerCase().includes(term) ||
    product.category?.toLowerCase().includes(term) ||
    product.sub_category?.toLowerCase().includes(term)
  );
};

const productService = {
  getProductById,
  getProductsByType,
  getAllProducts,
  getProductsByCategory,
  getProductsBySubCategory,
  searchProducts,
  arkansasTrademarkedSportNames
};

export default productService;
